import { code } from "@spscommerce/utils";

export const SpsZeroStatesExamples = {
  regular: {
    label: "Regular",
    examples: {
      regular: {
        template: code`
                  <sps-zero-state heading="No record found"
                    subHeading="Add new company.."
                    artwork="https://cdn.prod.spsc.io/web/framework/assets/18.03.02/images/icon-error.svg">
                  </sps-zero-state>
                `
      },
      withButton: {
        template: code`
                  <sps-zero-state heading="Search for a record"
                    subHeading="Add new companies by clicking the Add button below."
                    artwork="https://cdn.prod.spsc.io/web/framework/assets/18.03.02/images/icon-empty-search@2x.svg">
                    <sps-button kind="confirm">Add Record</sps-button>
                  </sps-zero-state>
                `
      },
      withSearch: {
        template: code`
                  <sps-zero-state heading="Search for a record"
                    subHeading="Find companies by using the search box below."
                    artwork="https://cdn.prod.spsc.io/web/framework/assets/18.03.02/images/icon-empty-search@2x.svg">
                    <sps-input-group>
                      <sps-text-input aria-label="Enter search"></sps-text-input>
                      <sps-button icon="search" kind="icon" aria-label="Search"></sps-button>
                    </sps-input-group>
                  </sps-zero-state>
              `
      }
    }
  },
  micro: {
    label: "Micro",
    examples: {
      inCard: {
        template: code`
                  <sps-card class="col-3">
                    <sps-card-header title="Attributes"></sps-card-header>
                      <sps-micro-zero-state icon="item-tag"
                        subHeading="This item doesn't have any attributes yet.">
                      </sps-micro-zero-state>
                  </sps-card>
                `
      },
      inWorkflow: {
        template: code`
                  <sps-workflow icon="list-summary" title="Workflow" class="col-3">
                    <sps-micro-zero-state icon="file" heading="No Document Found"
                      subHeading="There are no documents.">
                    </sps-micro-zero-state>
                  </sps-workflow>
              `
      }
    }
  }
};
